import { __assign } from "tslib";
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
export default (function (props) { return (React.createElement(FormattedMessage, __assign({}, props), function (translatedString) { return translatedString; })); });
//# sourceMappingURL=formatted-message.js.map